import { unref as _unref, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "m-0 text-sm text-gray-600"
}
const _hoisted_2 = {
  key: 1,
  class: "m-0 rounded-lg bg-[#f1f3f6] px-4 py-3 text-sm text-gray-700"
}
const _hoisted_3 = {
  key: 2,
  "data-closed-note": "",
  role: "status",
  class: "m-0 flex gap-2.5 rounded-md border border-[#fde68a] bg-[#fffbeb] px-3.5 py-3 text-sm text-[#92400e]"
}

import { computed } from 'vue'

import DateGrid from '@/components/neue/wizard/DateGrid.vue'
import HighlightedText from '@/components/neue/wizard/HighlightedText'
import WeekdayPicker from '@/components/neue/wizard/WeekdayPicker.vue'
import WizardIcon from '@/components/neue/wizard/WizardIcon.vue'
import WizardSection from '@/components/neue/wizard/WizardSection.vue'
import { injectWizard } from '@/composables/useWizardContext'
import { rhythmAllowsManyDays, sectionCopy, WEEKDAYS } from '@/config/dropWizardSteps'
import { formatDate } from '@/helpers/dropWizardDates'
import { dayNames } from '@/helpers/dropWizardSummary'


export default {
  __name: 'StepDay',
  props: {
  tz: { type: String, default: undefined },
  storeName: { type: String, default: 'your store' }
},
  setup(__props) {

const props = __props
const wizard = injectWizard()

const many = computed(() => rhythmAllowsManyDays(wizard.data.rhythm))

const pick = days => {
  wizard.data.weekdays = many.value ? days : days.slice(-1)
}

const orList = names =>
  names.length > 2 ? `${names.slice(0, -1).join(', ')} or ${names[names.length - 1]}` : names.join(' or ')

const severalDaysNote = computed(() => {
  const names = dayNames(wizard.data)
  return `Customers pick ${orList(names)} at checkout. Ordering closes before ${names[0]}, and they are charged once.`
})

const closedNote = computed(() => {
  const days = wizard.preview.value?.skipped_closed_days ?? []
  if (!days.length) return ''
  const list = days.map(day => formatDate(day.date, props.tz)).join(', ')
  return `${list} ${days.length === 1 ? 'is a closed day' : 'are closed days'} for ${props.storeName}. Ordering is off on ${days.length === 1 ? 'that date' : 'those dates'} and no reminders go out.`
})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(wizard).data.rhythm === 'once')
      ? (_openBlock(), _createBlock(WizardSection, _normalizeProps(_mergeProps({ key: 0 }, _unref(sectionCopy)('date', _unref(wizard).data))), {
          default: _withCtx(() => [
            _createVNode(DateGrid, {
              modelValue: _unref(wizard).data.date,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_unref(wizard).data.date) = $event)),
              tz: __props.tz
            }, null, 8, ["modelValue", "tz"])
          ]),
          _: 1
        }, 16))
      : (_openBlock(), _createBlock(WizardSection, _normalizeProps(_mergeProps({ key: 1 }, _unref(sectionCopy)('days', _unref(wizard).data))), {
          default: _withCtx(() => [
            _createVNode(WeekdayPicker, {
              "model-value": _unref(wizard).data.weekdays,
              days: _unref(WEEKDAYS),
              label: "Production days",
              "onUpdate:modelValue": pick
            }, null, 8, ["model-value", "days"]),
            (!many.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_1, " Pick one day. A drop that repeats every other week or every 4 weeks has one production day. "))
              : _createCommentVNode("", true),
            (many.value && _unref(wizard).data.weekdays.length > 1)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                  _createVNode(_unref(HighlightedText), { text: severalDaysNote.value }, null, 8, ["text"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 16)),
    (closedNote.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
          _createVNode(WizardIcon, { name: "bell" }),
          _createElementVNode("span", null, _toDisplayString(closedNote.value), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

}